import { useQuery } from '@tanstack/react-query';
import { fetchActiveIngredientsSearch } from '@common/services/productService';
import { ISubstanceDto } from '@common/features/submission/types';

export const queryKey = 'fetchActiveIngredients';

export const useFetchActiveIngredients = (search: string) => {
  const { data, isFetching: isFetchingActiveIngredients } = useQuery<ISubstanceDto[]>(
    [queryKey, search],
    () => fetchActiveIngredientsSearch(search),
    { enabled: search.trim().length >= 3 },
  );

  return {
    activeIngredients: search.trim().length >= 3 && !!data ? data : new Array<ISubstanceDto>(),
    isFetchingActiveIngredients,
  };
};